function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { BaseElement } from "../../lib/base-element.js";
import offerBoxStyles from "../../lib/offer-box-styles.js";
import { OfferPaymentMixin } from "../../lib/mixin/offer-payment-mixin.js";
import { ProductController } from "../../lib/product-display-controller.js";
import { quoteContext } from "../../lib/quote-context.js";
import { SelectedState } from "../../lib/selected-state.js";
import { provide } from "@lit/context";
import { html, css } from "lit";
import { property, queryAssignedElements, state, customElement } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var MultiOfferWrapperElement = /*#__PURE__*/function (_OfferPaymentMixin) {
  _inherits(MultiOfferWrapperElement, _OfferPaymentMixin);

  var _super = _createSuper(MultiOfferWrapperElement);

  function MultiOfferWrapperElement() {
    var _this;

    _classCallCheck(this, MultiOfferWrapperElement);

    _this = _super.call(this);
    _this.quotes = [];
    _this.productController = new ProductController(_assertThisInitialized(_this), function () {
      var _a, _b, _c, _d, _e;

      _this.quoteForProductDisplay = (_a = _this.productController) == null ? void 0 : _a.value;

      if ((_c = (_b = _this.productController) == null ? void 0 : _b.value) == null ? void 0 : _c.offer_id) {
        _this.offerId = (_e = (_d = _this.productController) == null ? void 0 : _d.value) == null ? void 0 : _e.offer_id;
      }
    });
    _this.selectedState = SelectedState.UNKNOWN;
    return _this;
  }
  /**
   * @ignore
   */


  _createClass(MultiOfferWrapperElement, [{
    key: "handleSlotchange",
    value: function handleSlotchange() {
      var _this2 = this;

      this._productElements.forEach(function (node, index) {
        node.clientId = _this2.clientId;
        node.multiMode = true;
        node.debug = false;
        node.dataset.uniqueId = index.toString();
        node.addEventListener("quote-error", function () {
          _this2.requestUpdate();
        });
        node.addEventListener("offer-state-change", function (e) {
          e.stopPropagation();
          e.stopImmediatePropagation();

          var quoteUpdates = _toConsumableArray(_this2.quotes);

          quoteUpdates[index] = e.detail;
          _this2.quotes = quoteUpdates;
          _this2.selectedState = _this2.quotes.some(function (q) {
            return q.selectedState === SelectedState[SelectedState.ACCEPTED];
          }) ? SelectedState.ACCEPTED : SelectedState.DECLINED;

          if (!_this2.quotes.includes(void 0)) {
            _this2.dispatchEvent(new CustomEvent("offer-state-change", {
              detail: quoteUpdates
            }));

            if (_this2.debug) {
              console.debug("Fired offer-state-change event", quoteUpdates);
            }
          }
        });
      });
    }
    /**
     * @ignore
     */

  }, {
    key: "_hasErrors",
    value: function _hasErrors() {
      return this._productElements.some(function (node) {
        var _a;

        return (_a = node.quoteController) == null ? void 0 : _a.error;
      });
    }
    /**
     * @ignore
     */

  }, {
    key: "_getErrorDisplayMessage",
    value: function _getErrorDisplayMessage() {
      var _a, _b;

      var error = (_b = (_a = this._productElements.find(function (node) {
        var _a2;

        return (_a2 = node.quoteController) == null ? void 0 : _a2.error;
      })) == null ? void 0 : _a.quoteController) == null ? void 0 : _b.error;

      if ((error == null ? void 0 : error.cause) === "StateNotAvailable" || (error == null ? void 0 : error.cause) === "ActivityNotAvailable") {
        return error.message;
      }
    }
    /**
     * @ignore
     */

  }, {
    key: "offerId",
    get: function get() {
      var _this3 = this;

      var _a;

      var offerId = (_a = document.cookie.split("; ").find(function (row) {
        return row.split("=")[0] === _this3.offerIdCookieName;
      })) == null ? void 0 : _a.split("=")[1];
      return offerId;
    }
    /**
     * @ignore
     */
    ,
    set: function set(offerId) {
      document.cookie = "".concat(this.offerIdCookieName, "=").concat(offerId, ";max-age=604800;");
    }
    /**
     * @ignore
     */

  }, {
    key: "offerIdCookieName",
    get: function get() {
      return "vertical_insure_offer_id:" + this.product;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _a;

      return (_a = this.productController) == null ? void 0 : _a.render({
        complete: function complete() {
          return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <div id=\"offer-display\">\n        <div id=\"offer-tag\">Recommended</div>\n        <offer-header></offer-header>\n        ", "\n        <section id=\"offer-content\">\n          <descriptor-list></descriptor-list>\n          <section id=\"actions\">\n            <slot @slotchange=", "></slot>\n          </section>\n        </section>\n        ", "\n        <legal-disclaimer></legal-disclaimer>\n      </div>\n    "])), when(_this4._hasErrors(), function () {
            return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          <div class=\"error-message\">\n            ", "\n          </div>\n        "])), _this4._getErrorDisplayMessage());
          }), _this4.handleSlotchange, _this4.renderPaymentElement());
        }
      });
    }
  }]);

  return MultiOfferWrapperElement;
}(OfferPaymentMixin(BaseElement));

MultiOfferWrapperElement.styles = [offerBoxStyles, css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      :host {\n        height: 100%;\n        margin-top: 10px;\n        max-width: 950px;\n      }\n\n      slot {\n        display: grid;\n        flex: 1;\n        row-gap: 10px;\n      }\n\n      ::slotted(*) {\n        margin: 0;\n      } \n\n      section#actions {\n        display: block;\n      }\n    "])))];

__decorateClass([property({
  attribute: "product"
})], MultiOfferWrapperElement.prototype, "product", 2);

__decorateClass([queryAssignedElements()], MultiOfferWrapperElement.prototype, "_productElements", 2);

__decorateClass([provide({
  context: quoteContext
}), state()], MultiOfferWrapperElement.prototype, "quoteForProductDisplay", 2);

__decorateClass([state()], MultiOfferWrapperElement.prototype, "quotes", 2);

MultiOfferWrapperElement = __decorateClass([customElement("multi-offer")], MultiOfferWrapperElement);
export { MultiOfferWrapperElement };